type CurrencyType = 'BEP20' | 'CELO_TOKEN' | 'COIN' | 'ERC20' | 'FIAT'

export enum CurrencyProduct {
  InterestBalance = 'InterestBalance',
  MercuryDeposits = 'MercuryDeposits',
  MercuryWithdrawals = 'MercuryWithdrawals',
  PrivateKey = 'PrivateKey',
  SimpleBuyBalance = 'SimpleBuyBalance'
}

export type ApiCurrency = {
  displaySymbol: string
  name: string
  precision: number
  products: CurrencyProduct[]
  symbol: string
  type: {
    erc20Address?: string
    logoPngUrl?: string
    minimumOnChainConfirmations?: number
    name: CurrencyType
    parentChain?: string
    websiteUrl?: string
  }
}
